"use client";
import { useState, useEffect } from "react";
import { FiMessageSquare, FiX } from "react-icons/fi";

export function ChatbaseButton({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (val: boolean) => void }) {
  return (
    <button
      onClick={() => setIsOpen(!isOpen)}
      className="a11y-no-highlight a11y-fab group relative flex h-14 w-14 items-center justify-center rounded-full bg-purple-600 hover:bg-purple-700 text-white shadow-lg transition-transform duration-200 hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-600/70"
      aria-label="Toggle AI Chat"
    >
      {isOpen ? <FiX className="h-7 w-7" /> : <FiMessageSquare className="h-7 w-7" />}
    </button>
  );
}

export function ChatbaseWindow({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (val: boolean) => void }) {
  const [hasOpened, setHasOpened] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setHasOpened(true);
    }
  }, [isOpen]);

  return (
    <div
      className={`fixed bottom-5 left-[90px] z-[99999] w-[calc(100vw-110px)] sm:w-[400px] h-[600px] max-h-[calc(100vh-40px)] min-h-[300px] rounded-2xl border border-purple-500/30 bg-[#0a0a0a] shadow-[0_0_40px_rgba(0,0,0,0.8)] transition-all duration-300 origin-bottom-left overflow-hidden flex flex-col ${
        isOpen ? "scale-100 opacity-100 pointer-events-auto translate-y-0" : "scale-90 opacity-0 pointer-events-none translate-y-4"
      }`}
    >
      <div className="flex items-center justify-between bg-purple-600/20 border-b border-purple-500/20 px-4 py-3 text-white backdrop-blur-md">
        <div className="flex items-center gap-2">
          <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-purple-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-purple-500"></span>
          </span>
          <span className="font-bold font-poppins text-sm tracking-wide">Aurex AI Support</span>
        </div>
        <button aria-label="Close Chat" onClick={() => setIsOpen(false)} className="text-white/60 hover:text-white transition-colors">
          <FiX className="h-5 w-5" />
        </button>
      </div>
      {hasOpened && (
        <iframe
          src="https://www.chatbase.co/chatbot-iframe/VJy9q1IPkzPfTiDfafRWB"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allow="microphone"
          loading="lazy"
          className="flex-1"
        ></iframe>
      )}
    </div>
  );
}
